var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "booking-section",
    {
      attrs: {
        id: "travel-dates",
        title: _vm.$t("booking.sectionTitles.datepicker"),
        contentClass: "price-date-picker",
        collapsed: _vm.moduleCollapsed
      },
      on: { "section-clicked": _vm.sectionClicked }
    },
    [
      _vm.loaded
        ? _c("div", [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "column small-12 large-6 large-order-2 hide-for-small-only"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: " booking-element",
                      class: { "hide-for-small-only": _vm.packages.length == 0 }
                    },
                    [
                      _c("div", { staticClass: "promotion__header" }, [
                        _c("img", { attrs: { src: "/images/diamond.svg" } }),
                        _vm._v(" "),
                        _vm.packages.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                attrs: { id: "packages-list-preview" }
                              },
                              [
                                _c("h3", { staticClass: "text-center" }, [
                                  _vm._v("Aktuelle Luxury Dreams Packages")
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.packages, function(pack, pi) {
                                  return _c(
                                    "div",
                                    {
                                      ref: "package" + pi,
                                      refInFor: true,
                                      staticClass: "package-details-wrapper",
                                      attrs: { id: "package" + pi }
                                    },
                                    [
                                      _c("span", {
                                        domProps: { innerHTML: _vm._s(pack) }
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "text-right" }, [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "cta cta--secondary cta--small cta--inline",
                                            on: {
                                              click: function($event) {
                                                return _vm.showPackageDetails(
                                                  "package" + pi
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Details")]
                                        )
                                      ])
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "hide-for-small-only",
                          domProps: { innerHTML: _vm._s(_vm.info) }
                        })
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "column small-12 large-6 large-order-1" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "booking-element",
                      attrs: { id: "airport_selector" }
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "column small-12" },
                          [
                            _c("label", [_vm._v("Abflughafen")]),
                            _vm._v(" "),
                            _c("booking-element-error", {
                              attrs: {
                                type: _vm.errorType,
                                msg: "please_pick_flight_option"
                              }
                            }),
                            _vm._v(" "),
                            _c("select2", {
                              attrs: {
                                options: _vm.airportSelectValues,
                                settings: {
                                  placeholder: "Bitte wählen Sie:",
                                  dropdownCssClass: "dropdown-shadow",
                                  multiple: true
                                }
                              },
                              on: { change: _vm.reloadFlightPrices },
                              model: {
                                value: _vm.booking.common.start_airports,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.booking.common,
                                    "start_airports",
                                    $$v
                                  )
                                },
                                expression: "booking.common.start_airports"
                              }
                            }),
                            _vm._v(" "),
                            (_vm.booking.common.start_airports &&
                              !_vm.booking.common.start_airports.length) ||
                            (this.booking.common.start_airports == null &&
                              this.booking.common.start_airports != "-")
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "cta cta--small cta--white",
                                    on: { click: _vm.disableFlight }
                                  },
                                  [_vm._v("Weiter ohne Flug")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "booking-element",
                      attrs: { id: "fare_type_selector" }
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "column small-12" }, [
                          _c("label", [_vm._v("Verpflegung")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "column small-12" },
                          [
                            _c("booking-element-error", {
                              attrs: {
                                type: _vm.errorType,
                                msg: "please_pick_fare_type"
                              }
                            }),
                            _vm._v(" "),
                            _c("select2", {
                              attrs: {
                                options: _vm.fareTypeSelectValues,
                                settings: _vm.dropdownOpts
                              },
                              model: {
                                value: _vm.booking.common.fare_type_id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.booking.common,
                                    "fare_type_id",
                                    $$v
                                  )
                                },
                                expression: "booking.common.fare_type_id"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.booking.setups, function(setup, i) {
                    return _c(
                      "div",
                      {
                        class:
                          "airport_selector booking-element booking-room-setup-container " +
                          (!_vm.personSetupValid ? "booking-error" : ""),
                        attrs: { id: "travellingPersons" }
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "column small-12" }, [
                            _c("label", [
                              _vm._v(_vm._s(i + 1) + ". Zimmer Belegung ")
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row" },
                          _vm._l(["adult", "kid"], function(personType) {
                            return _c(
                              "div",
                              {
                                staticClass:
                                  "column small-12 medium-6 text-right"
                              },
                              [
                                _c("select2", {
                                  ref: "" + personType + i,
                                  refInFor: true,
                                  attrs: {
                                    value: _vm.personsInRoom(i, personType)
                                      .length,
                                    options: _vm.paxDropdownValues[personType],
                                    settings: _vm.dropdownOptsMin
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.adjustPersons(i, personType)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.personsInRoom(i, "kid").length > 0
                          ? _c(
                              "div",
                              { staticClass: "row" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "column medium-6 small-12" },
                                  [_c("label", [_vm._v("Geburtsdaten Kinder")])]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.personsInRoom(i, "kid"), function(
                                  kid,
                                  ki
                                ) {
                                  return _c(
                                    "div",
                                    { staticClass: "column medium-4 small-12" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: kid.date_of_birth,
                                            expression: "kid.date_of_birth"
                                          }
                                        ],
                                        staticClass: "underline",
                                        attrs: {
                                          type: "text",
                                          placeholder: "TT.MM.JJJJ"
                                        },
                                        domProps: { value: kid.date_of_birth },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              kid,
                                              "date_of_birth",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.personSetupValid && _vm.personErrorMessage[i] != ""
                          ? _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "column small-12" },
                                [
                                  _c("booking-element-error", {
                                    attrs: {
                                      type: _vm.errorType,
                                      msg: _vm.personErrorMessage[i]
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "row room-setup-controls" }, [
                          _c("div", { staticClass: "column small-12" }, [
                            _c(
                              "a",
                              {
                                staticClass: "cta cta--inverse cta--inline",
                                on: {
                                  click: function($event) {
                                    return _vm.addRoom()
                                  }
                                }
                              },
                              [_vm._v("Zimmer hinzuf.")]
                            ),
                            _vm._v(" "),
                            i > 0
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "cta cta--dark cta--inline",
                                    on: {
                                      click: function($event) {
                                        return _vm.removeRoom(i)
                                      }
                                    }
                                  },
                                  [_vm._v("Entf.")]
                                )
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "row align-center small-collapse medium-uncollapse"
              },
              [
                _c("div", { staticClass: "column small-12" }, [
                  _c(
                    "div",
                    {
                      class:
                        "booking-element " +
                        (_vm.twoDaysSelected ? "dates-picked" : ""),
                      attrs: { id: "travel_dates_select" }
                    },
                    [
                      _vm.loaded && _vm.datepickerReady
                        ? _c("flat-pickr", {
                            attrs: { config: _vm.datePickerConfig },
                            model: {
                              value: _vm.booking.dates,
                              callback: function($$v) {
                                _vm.$set(_vm.booking, "dates", $$v)
                              },
                              expression: "booking.dates"
                            }
                          })
                        : _c("loader", {
                            attrs: {
                              title: "Daten werden geladen",
                              details: "Einen Moment bitte"
                            }
                          }),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "text-center small hide-for-small-only"
                        },
                        [
                          _vm._v(
                            "\n            Die angegebenen Preise zeigen den tagesaktuellen Übernachtungspreis pro Person/Nacht – bei der Berechnung des Gesamtreisepreises werden sowohl vorhandene Sonderpreise als auch ggf. zusätzliche Benefits berücksichtigt.\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.package_settings.min_days
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "text-center small hide-for-small-only"
                            },
                            [
                              _vm._v(
                                "\n            Die markierten Termine zeigen neben dem tagesaktuellem Übernachtungspreis pro Person/Nacht beispielhaft auch den\n            Paketpreis für " +
                                  _vm._s(_vm.package_settings.min_days) +
                                  " Nächte mit Flug, an denen LUXURY DREAMS Kunden exklusive Preis- und Leistungsvorteile erhalten.\n          "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.package_settings.offset &&
                      _vm.package_settings.offset != 0
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "text-center small hide-for-small-only"
                            },
                            [
                              _vm._v(
                                "\n            Bitte beachten Sie, dass die Ankunft in dieser Destinationen erst einen Tag nach Abreise erfolgt und Sie das Rückflugdatum entsprechend " +
                                  _vm._s(
                                    _vm.package_settings.min_days +
                                      _vm.package_settings.offset
                                  ) +
                                  " Nächte später auswählen. Bei Auswahl einer längeren Aufenthaltsdauer werden selbstverständlich die Preis- und Leistungsvorteile innerhalb des Aktionszeitraumes berücksichtigt.\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "column small-12" }, [
                _vm.dataReadyForCalculation
                  ? _c("div", { staticClass: "text-right booking-element" }, [
                      _c(
                        "a",
                        { staticClass: "cta", on: { click: _vm.loadResults } },
                        [_vm._v("Verfügbare Zimmer anzeigen")]
                      )
                    ])
                  : _c(
                      "div",
                      { staticClass: "booking-element booking-error" },
                      [
                        _vm.minStayOptions.stays > 0
                          ? _c("booking-element-error", {
                              attrs: {
                                msg: "min_stays_hint",
                                msgOptions: _vm.minStayOptions
                              }
                            })
                          : _c("booking-element-error", {
                              attrs: {
                                type: "error",
                                msg: _vm.currentStatusInfo
                              }
                            })
                      ],
                      1
                    )
              ]),
              _vm._v(" "),
              _vm.vp_enabled
                ? _c("div", { staticClass: "column small-12" }, [
                    _vm.partnerCodeValid
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "column small-4" }, [
                            _c("img", {
                              attrs: { src: _vm.current_vp.logo_url }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column small-8" }, [
                            _c("b", [
                              _vm._v(
                                "Aktiver Partner: " +
                                  _vm._s(_vm.current_vp.name)
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.current_vp.contact_name) +
                                "\n          "
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          ])
        : _c("loader", {
            attrs: {
              title: "Buchungsvorgang wird gestartet",
              details: "Einen Moment bitte"
            }
          }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "reveal",
          attrs: { id: "package-details-overlay", "data-reveal": "" }
        },
        [
          _c("div", { staticClass: "inner" }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "close-button",
              attrs: {
                "aria-label": "Popup schließen",
                "data-close": "",
                type: "button"
              }
            },
            [_vm._v("Fenster schließen ( x )")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }